<template>
  <div class="w1">
    <div class="wrap-admin" >
      <app-header />
      <inform-msg />
      <conf-popup />
      <div class="admin" :class="{'container-large': isInvitePage, 'full-page': isFullPage }">
        <router-view />
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppHeader from '@/components/common/AppHeader'
import ConfPopup from '@/components/common/ConfPopup'
import InformMsg from '@/components/common/InfomMsg'
import AppFooter from '@/components/main/common/AppFooter'

export default {
  name: 'admin',
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'profile'
    ]),
    isInvitePage () {
      let route = this.$route.name
      return route === 'add-user' || route === 'ca-add-user'
    },
    isFullPage () {
      let route = this.$route.name
      return route === 'add-article' || route === 'edit-article' ||
        route === 'add-todo' || route === 'edit-todo' || route === 'user-app' || route === 'company-tasks' ||
        route === 'company-task' || route === 'tasks' || route === 'task' || route === 'knowledge-base' ||
        route === 'complete-profile' || route === 'account-suspended' || route === 'renew-subscription'
    }
  },
  methods: {
    ...mapActions([
      'setFontSizeActive',
      'setColorPaletteActive',
      'getUser'
    ]),
    redirectCheck () {
      if (!this.profile) {
        return
      }
      let route = this.$route.name
      let allowThis = [
        'admin',
        'user-app',
        'give-consent',
        'notifications',
        'logs'
      ]
      if (this.profile.consent_status !== 1 && allowThis.indexOf(route) === -1) {
        let props = this.$router.resolve({
          name: 'give-consent'
        })
        this.$router.push(props.href)
      } else if (this.profile.company.suspended === true && route !== 'billing-profile' && route !== 'complete-profile' && route !== 'renew-subscription') {
        if (this.profile.company.subscription_end) {
          let props = this.$router.resolve({
            name: 'account-suspended'
          })
          this.$router.push(props.href)
        } else {
          let props = this.$router.resolve({
            name: 'billing-profile'
          })
          this.$router.push(props.href)
        }
      } else if (this.profile.company.is_temporary && route !== 'complete-profile' && route !== 'renew-subscription') {
        let props = this.$router.resolve({
          name: 'complete-profile'
        })
        this.$router.push(props.href)
      } else if (this.profile.password_changed === 1 && this.$route.name !== 'profile' && this.$route.name !== 'give-consent') {
        let props = this.$router.resolve({
          name: 'profile'
        })
        this.$router.push(props.href)
      }
    }
  },
  components: {
    AppHeader,
    ConfPopup,
    InformMsg,
    AppFooter
  },
  watch: {
    $route (to, from) {
      if (to !== from && this.getUserRole !== 'cu' && this.getUserRole !== 'sh') {
        this.redirectCheck()
      }
    },
    profile (user) {
      if (user) {
        this.redirectCheck()
      }
    }
  },
  beforeMount () {
    this.userData = JSON.parse(localStorage.getItem('userData'))
    if (this.userData.userRole !== 'gm' && this.$route.path === '/admin') {
      this.$router.push({
        path: '/dashboard'
      })
    }
  },
  mounted () {
    this.setFontSizeActive()
    this.setColorPaletteActive()
  },
  created () {
    this.getUser()
    if (this.getUserRole !== 'cu' && this.getUserRole !== 'sh') {
      this.redirectCheck()
    }
  }
}
</script>

<style src="@/assets/scss/components/admin.scss" lang="scss" />
<style src="@/assets/scss/main/common/footer.scss" lang="scss" />



// WEBPACK FOOTER //
// Admin.vue?16d9086e